import { IHelpCenterData, IHelpCenterDataAction, IHelpCenterContactFormData } from 'models/helpcenter/helpcenter';
import { IStore } from '../../IStore';
import { reset } from 'redux-form';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
import * as c from 'models/constants';
const { notifSend } = notifActions;

/** Action Types */
export const REQUEST_START: string = 'helpcenter/REQUEST_START';
export const REQUEST_SUCCESS: string = 'helpcenter/REQUEST_SUCCESS';
export const REQUEST_FAILURE: string = 'helpcenter/REQUEST_FAILURE';
export const SET_KEYWORD: string = 'helpcenter/SET_KEYWORD';

/** Initial State */
const initialState: IHelpCenterData = {
	isFetching: false,
	keyword: '',
	contactFormData: {
		name: '',
		surname: '',
		email: '',
		topic: null,
		message: '',
	},
};

/** Reducer */
export function helpCenterReducer(state = initialState, action: IHelpCenterDataAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});
		case REQUEST_SUCCESS:
			return initialState;

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case SET_KEYWORD:
			return Object.assign({}, state, {
				keyword: action.payload.keyword,
			});

		default:
			return state;
	}
}

/** Action Creator - create */
export function sendQuestionEmail(question: IHelpCenterContactFormData) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/HelpCenter/SendQuestionEmail',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(question),
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(reset(c.FORM_NAME_HELP_CENTER_CONTACT));
					dispatch(
						notifSend({ message: i18n.t('Notification_Success_RequestSent'), kind: 'success', dismissAfter: 3000 }),
					);
					dispatch(requestSuccess());
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(notifSend({ message: i18n.t('Error_Generic'), kind: 'danger', dismissAfter: 3000 }));
							dispatch(requestFailure(res));
							return true;
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(notifSend({ message: i18n.t('Error_Generic'), kind: 'danger', dismissAfter: 3000 }));
							dispatch(requestFailure(message));
							return true;
						});
				}
			})
			.catch((err) => {
				dispatch(notifSend({ message: i18n.t('Error_Generic'), kind: 'danger', dismissAfter: 3000 }));
				dispatch(requestFailure(err));
				return true;
			});
	};
}

/** Action Creator */
export function requestStart(): IHelpCenterDataAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function requestFailure(message: any): IHelpCenterDataAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function requestSuccess(): IHelpCenterDataAction {
	return {
		type: REQUEST_SUCCESS,
	};
}

/** Action Creator */
export function setKeyword(keyword: string): IHelpCenterDataAction {
	return {
		type: SET_KEYWORD,
		payload: {
			keyword,
		},
	};
}
